import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../shared.module';

import { LabelService } from '../../services/label.service';

@Component({
  selector: 'app-panel-error',
  standalone: false,
  templateUrl: './panel-error.component.html',
  styleUrl: './panel-error.component.scss',
})
export class PanelErrorComponent {
  @Output() close = new EventEmitter<void>();
  @Input() errorMessage: string = '';

  constructor(public labelService: LabelService) {}

  onClose() {
    this.close.emit();
  }
}
